import css from './index.module.scss';
import A from './components/A';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import J from './components/J';
import K from './components/K';

export default function SP160wSingle() {
    return (
        <div className={`sp-160w-single ${css['sp-160w-single']}`}>
            <A />
            <B />
            <C />
            <D />
            <K />
            <div className="gray-box">
                <E />
                <F />
                <G />
            </div>
            <H />
            <I />
            <J />
        </div>
    );
}
